import React from 'react';
import PropTypes from 'prop-types';
import withIntl from '../../../../components/Intl/WithIntl';

import HtmlComponent from '../../../../components/Text/HtmlComponent';

// temporary work-around (see https://github.com/yahoo/babel-plugin-react-intl/issues/119)
function FormattedHTMLMessage({ intl, id, defaultMessage, values = {} }) {
  return <HtmlComponent text={intl.formatMessage({ id, defaultMessage }, values)} />;
}
FormattedHTMLMessage.propTypes = {
    intl: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
    values: PropTypes.object,
};
export default withIntl(FormattedHTMLMessage);
